var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg121(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.181,
    height: 48,
    viewBox: "0 0 37.181 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "painting_1_",
    "data-name": "painting (1)",
    transform: "translate(-57.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M78.822,0H73.757A1.859,1.859,0,0,0,71.9,1.857v1.1H59.706A2.009,2.009,0,0,0,57.7,4.965V28.741a2.009,2.009,0,0,0,2.007,2.007h2.8v1.1a1.859,1.859,0,0,0,1.857,1.857h3.373L61.922,43.777a1.486,1.486,0,0,0,.543,2.027l1.209.7a1.483,1.483,0,0,0,2.027-.543l7.074-12.253h1.331V46.516A1.486,1.486,0,0,0,75.591,48h1.4a1.486,1.486,0,0,0,1.484-1.484V33.706H79.8l7.074,12.253A1.483,1.483,0,0,0,88.9,46.5l1.209-.7a1.486,1.486,0,0,0,.543-2.027L84.842,33.707h3.373a1.859,1.859,0,0,0,1.857-1.857v-1.1h2.8a2.009,2.009,0,0,0,2.007-2.007V13.9a.7.7,0,0,0-1.406,0v8.047L89.45,17.933a2.343,2.343,0,0,0-3.4.094l-3.344,3.726a.937.937,0,0,1-1.372.027l-3.324-3.428a.7.7,0,1,0-1.01.979l3.324,3.428a2.347,2.347,0,0,0,3.428-.066L87.1,18.967a.938.938,0,0,1,1.361-.038l5.016,5v4.811a.6.6,0,0,1-.6.6H59.706a.6.6,0,0,1-.6-.6V22.568L69.111,12.562a.938.938,0,0,1,1.337.01l4.268,4.4A.7.7,0,0,0,75.725,16l-4.268-4.4a2.344,2.344,0,0,0-3.341-.026l-9.011,9.011V4.965a.6.6,0,0,1,.6-.6H92.873a.6.6,0,0,1,.6.6v5.651a.7.7,0,0,0,1.406,0V4.965a2.009,2.009,0,0,0-2.007-2.007H80.679v-1.1A1.859,1.859,0,0,0,78.822,0ZM64.484,45.256a.078.078,0,0,1-.106.028l-1.209-.7a.078.078,0,0,1-.029-.106l6.22-10.774h1.792Zm12.581,1.26a.078.078,0,0,1-.078.078h-1.4a.078.078,0,0,1-.078-.078V33.706h1.552ZM89.439,44.48a.078.078,0,0,1-.029.106l-1.209.7a.078.078,0,0,1-.106-.028l-6.668-11.55h1.792Zm-.773-13.732v1.1a.457.457,0,0,1-.451.451H64.364a.457.457,0,0,1-.451-.451v-1.1ZM73.306,1.857a.457.457,0,0,1,.451-.451h5.065a.457.457,0,0,1,.451.451v1.1H73.306Z",
    transform: "translate(0)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M283.659,92.345a3.311,3.311,0,1,0-3.312,3.312A3.315,3.315,0,0,0,283.659,92.345Zm-3.312,1.905a1.905,1.905,0,1,1,1.905-1.905A1.907,1.907,0,0,1,280.347,94.251Z",
    transform: "translate(-198.774 -80.687)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M306.264,58.048v-.866a.7.7,0,0,0-1.406,0v.866a.7.7,0,0,0,1.406,0Z",
    transform: "translate(-223.987 -51.184)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M304.858,168.7v.866a.7.7,0,1,0,1.406,0V168.7a.7.7,0,0,0-1.406,0Z",
    transform: "translate(-223.987 -152.251)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M263.978,75.977a.7.7,0,0,0,0-.994l-.612-.612a.7.7,0,1,0-.994.994l.612.612A.7.7,0,0,0,263.978,75.977Z",
    transform: "translate(-185.297 -67.211)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M341.841,154.835a.7.7,0,0,0,.994-.994l-.612-.612a.7.7,0,1,0-.994.994Z",
    transform: "translate(-256.762 -138.676)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M245.184,116.856a.7.7,0,1,0,0,1.406h.866a.7.7,0,0,0,0-1.406Z",
    transform: "translate(-169.271 -105.901)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M357.572,118.262a.7.7,0,0,0,0-1.406h-.866a.7.7,0,0,0,0,1.406Z",
    transform: "translate(-270.337 -105.901)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M263.365,154.835l.612-.612a.7.7,0,0,0-.994-.994l-.612.612a.7.7,0,0,0,.994.994Z",
    transform: "translate(-185.296 -138.676)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M342.224,75.977l.612-.612a.7.7,0,0,0-.994-.994l-.612.612a.7.7,0,1,0,.994.994Z",
    transform: "translate(-256.762 -67.211)",
    fill: "#f24462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg121);
export default __webpack_public_path__ + "static/media/121.bcbc2637.svg";
export { ForwardRef as ReactComponent };